export const getFileSizeInKB = (bytes: number) => {
  return `${Math.ceil(bytes / 1000)} KB`;
};
